const getNotifyMeList = state => state.notifyme || {};

const isLoading = state => getNotifyMeList(state).loading;
const getData = state => getNotifyMeList(state).data || {};
const getEntries = state => getData(state).results || [];
const getEntry = (state, productCode) =>
    getEntries(state)
        .filter(entry => entry.product.code === productCode)
        .pop() || null;

export default {
    isLoading,
    getData,
    getEntries,
    getEntry,
};
